// advup — formato de arquivo do GED (ver docs/PARIDADE-GED.md).
//
// Compartilhado pelas três telas que listam documento: GED central, aba GED
// do processo e aba GED do cliente. As classes CSS correspondentes vivem em
// assets/scss/_advup-file-format.scss (globais pelo mesmo motivo).

/**
 * @typedef {Object} FileFormat
 * @property {string} icon - classe do ícone lucide
 * @property {string} label - rótulo legível ("PDF", "Word", "Excel")
 * @property {string} tone - sufixo da classe de cor (`fmt--<tone>`)
 */

/** @type {Record<string, FileFormat>} */
const FORMAT_BY_EXTENSION = {
  pdf: { icon: 'i-lucide-file-text', label: 'PDF', tone: 'pdf' },
  doc: { icon: 'i-lucide-file-type', label: 'Word', tone: 'word' },
  docx: { icon: 'i-lucide-file-type', label: 'Word', tone: 'word' },
  xls: { icon: 'i-lucide-file-spreadsheet', label: 'Excel', tone: 'excel' },
  xlsx: { icon: 'i-lucide-file-spreadsheet', label: 'Excel', tone: 'excel' },
  csv: { icon: 'i-lucide-file-spreadsheet', label: 'CSV', tone: 'excel' },
  ppt: { icon: 'i-lucide-presentation', label: 'PowerPoint', tone: 'ppt' },
  pptx: { icon: 'i-lucide-presentation', label: 'PowerPoint', tone: 'ppt' },
  png: { icon: 'i-lucide-image', label: 'Imagem', tone: 'image' },
  jpg: { icon: 'i-lucide-image', label: 'Imagem', tone: 'image' },
  jpeg: { icon: 'i-lucide-image', label: 'Imagem', tone: 'image' },
  gif: { icon: 'i-lucide-image', label: 'Imagem', tone: 'image' },
  webp: { icon: 'i-lucide-image', label: 'Imagem', tone: 'image' },
  zip: { icon: 'i-lucide-file-archive', label: 'ZIP', tone: 'zip' },
  rar: { icon: 'i-lucide-file-archive', label: 'RAR', tone: 'zip' },
  txt: { icon: 'i-lucide-file-text', label: 'Texto', tone: 'text' },
  mp3: { icon: 'i-lucide-file-audio', label: 'Áudio', tone: 'media' },
  mp4: { icon: 'i-lucide-file-video', label: 'Vídeo', tone: 'media' },
};

/**
 * Formato a partir do nome do arquivo.
 * Documento antigo pode não ter `file_name` — nesse caso volta o genérico
 * em vez de quebrar, que é o comportamento que a lista precisa.
 * @param {string|null|undefined} fileName
 * @returns {FileFormat}
 */
export function fileFormatFor(fileName) {
  const ext = (fileName || '').split('.').pop()?.toLowerCase() || '';
  return (
    FORMAT_BY_EXTENSION[ext] || {
      icon: 'i-lucide-file',
      label: ext ? ext.toUpperCase() : '—',
      tone: 'default',
    }
  );
}

export { FORMAT_BY_EXTENSION };
